import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { MessagesApi, RequestStrategyEnum, type GetMessagesResponse } from '@shared/api';

interface UseMessagesStore {
  loading: boolean;
  data: GetMessagesResponse[];
  error: string | null;
  getMessages: (type: 'incomming' | 'outgoing', signal?: AbortSignal) => Promise<void>;
  readMessage: (messageId: string) => void;
  clear: () => void;
}

export const useMessagesStore = create<UseMessagesStore>((set, get) => ({
  loading: false,
  error: null,
  data: [],

  getMessages: ApiUtils.wrapperApi(async (type, signal) => {
    try {
      set({ loading: true, error: null, data: [] });
      const result = await MessagesApi.getMessages(type, signal);
      set({ data: result || [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  readMessage: (messageId: string) =>
    set({
      data: get().data.map((message) => {
        if (message.Id === messageId) return { ...message, UnreadFlag: false };
        return message;
      }),
    }),

  clear: () => set({ loading: false, error: null, data: [] }),
}));
